<template>
    <div
        :class="[
            $validator.has(validatorName, sid)
                ? 'border-red hover:border-red-darker'
                : 'hover:border-grey-light',
            {
                'bg-blue border-blue shadow-inner': checked
            },
            disabled
                ? 'cursor-not-allowed ' + (checked ? 'bg-blue-dark!' : 'bg-grey-bg')
                : isInteractive ? 'cursor-pointer focus:shadow-outline' : ''
        ]"
        class="inline-flex items-center inline-block w-5 h-5 mt-0.5 text-white border rounded-full focus:outline-none"
        role="radio"
        tabindex="0"
        @click.prevent="toggle"
        @keydown.space.prevent="toggle"
    >
        <div
            v-show="checked"
            class="w-2 h-2 mx-auto bg-white rounded-full"
        />

        <input
            :value="value"
            type="radio"
            class="hidden"
        >
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'model'
        },
        props: {
            model: {
                type: String,
                required: true
            },
            value: {
                type: String,
                required: true
            },
            validatorName: {
                type: String,
                default: null
            },
            sid: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            isInteractive: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            checked () {
                return this.model === this.value
            }
        },
        methods: {
            toggle () {
                console.log('toggled', this.value)

                this.$emit('input', this.value)
            }
        }
    }
</script>
